function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9278 2.57929C19.701 1.73586 19.036 1.071 18.1927 0.843895C16.6521 0.422363 10.4895 0.422363 10.4895 0.422363C10.4895 0.422363 4.32719 0.422363 2.78658 0.827913C1.9595 1.05478 1.27829 1.73598 1.05143 2.57929C0.645996 4.11978 0.645996 7.31455 0.645996 7.31455C0.645996 7.31455 0.645996 10.5254 1.05143 12.0498C1.27853 12.8931 1.94328 13.558 2.7867 13.7851C4.34341 14.2067 10.4897 14.2067 10.4897 14.2067C10.4897 14.2067 16.6521 14.2067 18.1927 13.8012C19.0361 13.5742 19.701 12.9093 19.9281 12.066C20.3334 10.5254 20.3334 7.33077 20.3334 7.33077C20.3334 7.33077 20.3496 4.11978 19.9278 2.57929ZM8.52748 10.266V4.36311L13.652 7.31455L8.52748 10.266Z",
  fill: "currentColor"
});

function SvgYouTubeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeLogo);
export default __webpack_public_path__ + "static/media/you-tube-logo.617be3f3.svg";
export { ForwardRef as ReactComponent };